import { useEffect, useState } from "react"
import Primarytheme from '../utility/theme';
import { fetchIntegrations, fetchPlytixBearerToken } from "./PlytixModule"
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';


export default function PlytixProductList({ conf, setConf, groupKey, i }) {

    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(null)
    const [productLists, setProductLists] = useState(null)


    // metodo per scaricare le product list disponibili
    const fetchPlytixProductList = async (access_token) => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", `Bearer ${access_token}`);

        var raw = JSON.stringify({
            "filters": [
                []
            ],
            "relationship_filters": [],
            "pagination": {
                "page_size": 100,
                "page": 1,
                "order": "name"
            },
            "attributes": [
                "name",
                "query",
                "relationship_filters",
            ]
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        const res = await fetch("https://pim.plytix.com/api/v1/lists/product/search", requestOptions)
            .then(response => response.text())
            .then(result => { return result })
        const data = JSON.parse(res).data || null
        return data
    }


    useEffect(() => {
        const fetchProductLists = async () => {
            setLoading(true);
            //fetch servizi per API key plytix
            const services = await fetchIntegrations(setError, conf.project_id);
            if (services !== null) {
                let plytixService = services.filter(s => s.serviceName == 'Plytix')
                if (plytixService[0].lastUpdated === null) {
                    setError("Plytix integration NOT configured.");
                }
                else {
                    // fetch credenziali integrazione Plytix
                    plytixService = plytixService[0]
                    const api_key = plytixService.parameters.filter((p) => p.label == "API Key")[0].value;
                    const api_password = plytixService.parameters.filter((p) => p.label == "API Password")[0].value;
                    // fetch Plytix Bearer Token
                    const plytixAccessToken = await fetchPlytixBearerToken(setError, api_key, api_password)
                    if (plytixAccessToken) {
                        // fetch dei product list da plytix
                        const pl = await fetchPlytixProductList(plytixAccessToken)
                        setProductLists(pl)
                    }
                }
            }

            setLoading(false);
        };
        fetchProductLists();
    }, []);


    const handleChange = (event, newValue) => {
        let newConf = { ...conf }
        newConf.integrationsOptions[groupKey][i].value = newValue
        setConf(newConf)
    }


    return (
        <Stack sx={{ mb: '1em', mt: '2em' }}>
            {error && (
                <Alert severity="error" variant="outlined" sx={{ mb: 1 }}>
                    {error}
                </Alert>
            )}
            <Stack direction='row' alignItems='center'>
                <Autocomplete
                    id="plytix-product-list-selector"
                    size='small'
                    options={productLists || []}
                    getOptionLabel={(option) => option.name || ''}
                    isOptionEqualToValue={(option, val) => option.id === val.id}
                    value={conf.integrationsOptions[groupKey][i].value || null}
                    onChange={handleChange}
                    loading={loading}
                    disabled={!!error}
                    noOptionsText="No product lists available"
                    clearOnEscape
                    sx={{ maxWidth: 300, flexGrow: 1 }}
                    renderOption={(props, option) => {
                        const { key, ...optionProps } = props;
                        return (
                            <li key={key} {...optionProps}>
                                <Stack direction='row' alignItems='center' justifyContent="space-between" width="100%">
                                    <Typography variant="body2">{option.name}</Typography>
                                    <Chip label={option.type} size="small" variant="outlined"
                                        color={option.type === 'Smart' ? 'primary' : 'default'}
                                    />
                                </Stack>
                            </li>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={conf.integrationsOptions[groupKey][i].nome || "Product List"}
                            error={!!error}
                            slotProps={{
                                input: {
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading && <CircularProgress color="inherit" size={20} />}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                },
                            }}
                        />
                    )}
                />
                <Tooltip title={
                    <Typography variant='caption' >
                        {conf.integrationsOptions[groupKey][i].descrizione}
                    </Typography>}>
                    <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
                </Tooltip>
            </Stack>
        </Stack>
    )
}